module.exports = __webpack_public_path__ + "static/ab4-765b6cb5855c21d4bf18a03cda3f7448.png";